@import (reference) '../../../../../../../constants/spacing.module.less';

.comparison-table-container {
  flex: 1;
  min-width: 400px;
}

.comparison-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 4px;
  border: 1px solid var(--gray-E4E5E7);
  overflow: hidden;

  color: var(--gray-45505B);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  /* Shadows/boxshadow-md */
  box-shadow:
    0 2px 6px 0 rgba(0, 0, 0, 0.1),
    0 0 15px 0 rgba(0, 0, 0, 0.1);
}

.comparison-table-cell {
  padding: @space-8 @space-16;
  text-align: left;
  border-bottom: 1px solid var(--gray-DFE4E8);
}

.comparison-table-header {
  .comparison-table-cell();
  background-color: var(--green-052E1A);
  color: var(--white);
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;

  &:first-child {
    border-top-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
  }
}

.comparison-table-body-cell {
  .comparison-table-cell();
  background-color: var(--white);
  color: var(--gray-45505B);
  height: 40px;

  &:last-child {
    font-weight: 700;
  }
}

.comparison-table-body-row:last-child .comparison-table-body-cell {
  border-bottom: none;

  &:first-child {
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-bottom-right-radius: 4px;
  }
}

.comparison-table-metric-cell {
  display: flex;
  flex-flow: row nowrap;
  gap: @space-8;
  align-items: center;
}

.metric-improvement-tag {
  display: flex;
  padding: 2px @space-8;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--green-B6F6D7);
  background: var(--green-EDFDF5);
  color: var(--green-007733);
  height: 20px;
}
